import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Card, CardContent } from '@marine/ui/card';
import { useAuth, useCurrentUser } from '../../hooks/useAuth';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { isLoading: isQueryLoading } = useCurrentUser();
  const location = useLocation();
  const isChecking = isLoading || (isAuthenticated && isQueryLoading);

  if (isChecking) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-background px-6 py-10">
        <Card className="w-full max-w-sm">
          <CardContent className="p-6">
            <div className="flex flex-col items-center gap-3 text-center">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
                <Loader2 className="h-5 w-5 animate-spin" />
              </div>
              <div className="text-sm font-medium">Loading platform</div>
              <div className="text-xs text-muted-foreground">Checking your session and permissions.</div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
